
<script src="https://ajax.googleapis.com/ajax/libs/angularjs/1.6.9/angular.min.js"></script>

<div id="globalGlobalContainer">
  <div id="GreekParallax"></div>
<app-messages *ngIf="Message"></app-messages>
<div id="globalContainer">
  
  <div id="header">
    <nav>
      <a routerLink="/dashboard">Dashboard</a>
      <a routerLink="/articles" *ngIf="!LoginMode" (click)="inversLogin()">Add a new Article</a>
      <a routerLink="/articles" *ngIf="LoginMode" (click)="inversLogin()">Myth Classed</a>
      <a routerLink="/familyTree">Family Tree</a>
      <a routerLink="/galery">Gallery</a>
    </nav>
  </div>
  <div id="animation">
  <div id="container0">
  <app-article-search *ngIf="!LoginMode" (click)="function()"></app-article-search>
  <div id="dontFind"*ngIf="!LoginMode"> Don't find the myth you are looking for ? <span (click)="inversLogin()" id="noCss">Let's create it so !</span></div><br>
  <div id="container-1" *ngIf="LoginMode">
    <form>
    <br>

    <label id="new-hero">Name of the Myth: </label>
    <input for="new-hero" #articleName /><br>
    <label id="new-hero">Myth Title / HeadLine </label>
    <input for="new-hero" #articleTitle /><br>
    <label id="new-hero">Content of the Myth </label>
    <input for="new-hero" #articleDescription/><br>
    <label id="new-hero">Select a Category </label><br>
    <select for="new-hero" #articleType>
      <option value="God">Olympian God</option>
      <option value="Titan">Titan</option>
      <option value="MinorGod">Minor God</option>
      <option value="Monster">Monster</option>
      <option value="Hero">Hero</option>
      <option value="Other">Other</option>
    </select><br><br>
    <label id="new-hero" >Url of an Image (optional)</label>
    <input for="new-hero" #articleImageUrl /> <br>
    <label id="new-hero" >Author / Sign your Article</label>
    <input for="new-hero" #articleAuthor /> 
    <!-- (click) passes input value to add() and then clears the input -->
    <button type="submit" class="add-button" ng-if=""(click)="add(articleName.value,articleTitle.value,articleDescription.value,articleType.value, articleImageUrl.value, articleAuthor.value); articleName.value=''; articleDescription.value=''; articleTitle.value=''; articleType.value=''; articleImageUrl.value='';" >
      Share this brand new Article ! 
    </button>
    <span style="color:red; padding-left: 10px;">Every field are required, either way the article won't be saved</span>
    <br><br>
    </form>
  </div>

</div>
<br><br>

<div id="container1">
  <br>
  <div class="headerContainer" >
    Olympians God's Article Available
  </div>
  
  <div class="articles">
    <ul class="ListMonster">
      <br>
      <li *ngFor="let article of filterType('God'); index as i;"  routerLink="/detail/{{article.id}}">
        <span class="badge">{{i+1}}</span> <span style="font-size: larger; font-weight: 400;">{{article.name}}</span> | <span style="font-size: smaller;">{{article.author}}</span>
        <button class="delete" title="delete article" *ngIf="AdminMode"
          (click)="delete(article)">x</button> 
      </li>
    </ul>
  <br>
  </div>
</div>
<br><br><br><br>

<div id="containerMonsterHero">
<div id="container2">
  <br>
  <div class="headerContainer">
    Titan's
  </div>
  
  <div class="articlesMini">
    <ul class="ListMonster">
      <br>
      <li *ngFor="let article of filterType('Titan'); index as i;"  routerLink="/detail/{{article.id}}">
        <span class="badge">{{i+1}}</span> <span style="font-size: larger; font-weight: 400;">{{article.name}}</span> | <span style="font-size: smaller;">{{article.author}}</span>
        <button class="delete" title="delete article" *ngIf="AdminMode"
          (click)="delete(article)">x</button> 
      </li>
    </ul>
  <br>
  </div>
</div>


<div id="container3">
  <br>
  <div class="headerContainer">
    Minor God's
  </div>
  
  <div class="articlesMini">
    <ul class="ListStory">
      <br>
      <li *ngFor="let article of filterType('MinorGod'); index as i;"  routerLink="/detail/{{article.id}}">
          <span class="badge">{{i+1}}</span> <span style="font-size: larger; font-weight: 400;">{{article.name}}</span> | <span style="font-size: smaller;">{{article.author}}</span>
          <button class="delete" title="delete article" *ngIf="AdminMode"
          (click)="delete(article)">x</button>     
        </li>
    </ul>
  <br>
  </div>
</div>
</div>
<br><br><br>

<div id="containerMonsterHero">
  <div id="container4">
    <br>
    <div class="headerContainer">
      Hero's
    </div>
    
    <div class="articlesMini">
      <ul class="ListMonster">
        <br>
        <li *ngFor="let article of filterType('Hero'); index as i;"  routerLink="/detail/{{article.id}}">
          <span class="badge">{{i+1}}</span> <span style="font-size: larger; font-weight: 400;">{{article.name}}</span> | <span style="font-size: smaller;">{{article.author}}</span>
          <button class="delete" title="delete article" *ngIf="AdminMode"
            (click)="delete(article)">x</button> 
        </li>
      </ul>
    <br>
    </div>
  </div>
  
  
  <div id="container5">
    <br>
    <div class="headerContainer">
      Monster's
    </div>
    
    <div class="articlesMini">
      <ul class="ListStory">
        <br>
        <li *ngFor="let article of filterType('Monster'); index as i;"  routerLink="/detail/{{article.id}}">
            <span class="badge">{{i+1}}</span> <span style="font-size: larger; font-weight: 400;">{{article.name}}</span> | <span style="font-size: smaller;">{{article.author}}</span>
            <button class="delete" title="delete article" *ngIf="AdminMode"
            (click)="delete(article)">x</button>     
          </li>
      </ul>
    <br>
    </div>
  </div>
  </div>
</div>
</div>
<div id="GreekParallax"></div>
</div>



